module.exports = __webpack_public_path__ + "img/logo.a870fe5b.svg";